<template>
  <div class="flex product-list">
    <div class="img-content" v-if="showImage">
      <van-image class="custom-image" width="60" height="60" :src="item.itemThumbnail">
        <slot><span v-if="isDrugItem && item.isRx === RxTypeNum.CHUFANGYA0" class="prescription"></span></slot>
        <slot><span v-if="isDrugItem && item.isRx === RxTypeNum.OTC" class="otc"></span></slot>
      </van-image>
    </div>
    <div class="right">
      <div class="name-container">
        <div class="name ellipsis">
          {{ item.itemName }}
        </div>
        <span v-if="showAction" class="item-num">x{{ item.itemNumber }}</span>
      </div>

      <div class="size">规格：{{ item.drugSpec }}</div>
      <div class="flex space-between" style="align-items: center; margin-top: 10px">
        <div class="price">
          {{ item.itemRealPrice | parsePrice }}
        </div>
        <div class="action" v-if="showAction">
          <van-stepper
            :ref="'stepper' + item.orderDetailId"
            v-model="item.refundNum"
            theme="round"
            integer
            :show-minus="item.refundNum > 0"
            :min="item.canRefund ? 1 : 0"
            :max="item.canRefund ? item.maxRefundNum : 0"
            button-size="22"
            :disable-input="item.refundNum === 0"
          />
        </div>
        <div v-else class="item-num">x{{ item.refundNum }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { RxTypeNum } from '@/constant';

export default {
  props: ['item', 'showBorder', 'showAction', 'showImage'],
  data() {
    return {
      RxTypeNum,
      digit: ''
    };
  },
  computed: {
    isDrugItem() {
      return this.item.isDrug === 1;
    }
  },
  methods: {
    emitChange(refundNum) {
      this.$emit('countChange', refundNum);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list {
  width: 100%;
  position: relative;

  .drop-image {
    position: absolute;
    top: 0;
    left: 0;
  }
}
.img-content {
  position: relative;
  width: 60px;
  min-width: 60px;
  .custom-image {
    overflow: hidden;
    border-radius: 4px;
    background: #fafafa;
  }
  .prescription {
    background: url('../../../assets/imgs/tag_chufang.png') no-repeat top left/100% 100%;
    width: 32px;
    height: 14px;
    display: inline-block;
    position: absolute;
    top: 4px;
    left: 4px;
  }
  .otc {
    background: url('../../../assets/imgs/tag_otc.png') no-repeat top left/100% 100%;
    width: 32px;
    height: 14px;
    display: inline-block;
    position: absolute;
    top: 4px;
    left: 4px;
  }
}
.item-num {
  color: #8c8c8c;
  font-size: 12px;
  min-width: 18px;
  text-align: right;
}
.right {
  margin-left: 12px;
  flex: 1;
  .name-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .name {
    font-size: 14px;
    line-height: 14px;
    color: #262626;
    font-weight: 400;
    flex: 1;
  }
  .size {
    line-height: 12px;
    margin-top: 8px;
    font-size: 12px;
    color: #8c8c8c;
  }
  .price {
    max-width: 50%;
    font-size: 14px;
    font-weight: 500;
    color: #f94242;
    line-height: 24px;
  }

  .sub_button {
    width: 88px;
    height: 24px;
    padding: 0;
    font-size: 12px !important;
    border-radius: 4px;
  }
  ::v-deep.van-stepper__minus {
    color: #262626;
    background-color: #fff;
    border: 1px solid #118dff;
  }
  ::v-deep.van-stepper__plus {
    color: #fff;
    background-color: #1e8dff;
  }
  ::v-deep.van-stepper__plus,
  ::v-deep.van-stepper__minus {
    border-radius: 6px;
  }
}
</style>
